require('./css/inline.css');
require('pace-progress');
require('./js/router.js');

